<template>
  <div style="height: 100%;width: 100%">
    <div
      class="echart-pie"
      ref="echartPie"
      v-show="!noData"
    >
    </div>
    <no-data v-show="noData"></no-data>
  </div>
</template>

<script>
/*
   * 柱状图，传入参数widgetId 柱状图数据id
   * */
import noData from './no-data'
import api from 'api/api'
export default {
  name: 'echart-pie',
  props: {
    widgetId: {
      // 饼图数据请求id
      type: String,
      default: ''
    },
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    }
  },
  components: {
    noData
  },
  data () {
    return {
      noData: false,
      option: {
        tooltip: {
          show: true
        },
        color: [
          '#6282f7',
          '#fc86ad',
          '#fcb3cc',
          '#fcd7e3',
          '#faac84',
          '#fccf92',
          '#faea9b'
        ],
        legend: {
          right: 0,
          top: 12,
          data: []
        },
        series: [
          {
            name: '',
            type: 'pie',
            label: {
              normal: {
                show: false
              }
            },
            radius: [0, '50%'],
            data: []
          }
        ]
      },
      echartObj: null
    }
  },
  mounted () {
    this.init()
    this.loopRefreshWidget()
    window.addEventListener('resize', this.resizeEchart)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeEchart)
    this.echartObj = null
  },
  methods: {
    // 轮巡请求
    loopRefreshWidget () {
      if (this.refreshPeriod !== 0) {
        setInterval(() => {
          this._getData()
        }, this.refreshPeriod * 1000)
      }
    },
    init () {
      this.echartObj = this.$echarts.init(this.$refs.echartPie)
      this._getData()
    },
    // 获取数据
    _getData () {
      api.widget
        .getData(this.widgetId)
        .then(data => {
          this.option.series[0].data = data.data.list
          if (this.option.series[0].data) {
            this.noData = false
          } else {
            this.noData = true
          }
          this.option.legend.data = []
          data.data.list.forEach(item => {
            this.option.legend.data.push({
              name: item.name,
              icon: 'circle'
            })
          })
          this.echartObj.setOption(this.option)
        })
        .catch(() => {
          this.noData = true
        })
    },
    resizeEchart () {
      this.echartObj.resize()
    }
  },
  watch: {
    widgetId () {
      this.init()
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";
.echart-pie {
  width: 100%;
  height: 100%;
}
</style>
